import React from 'react';
import { connectToStore } from '../../../store';
import styles from './SessionDetails.module.scss';

function SessionDetails() {
	return <div className={styles.sessionDetails}>Session Details - Work in Progress</div>;
}

export default connectToStore(SessionDetails);
